import styled from 'styled-components'

export const Section = styled.section`
  padding: ${({ theme }) => theme.spacing['4xl']} 0;
  position: relative;
  width: 100%;

  &.with-background {
    background: ${({ theme }) => theme.colors.backgroundLight};
  }

  &.dark {
    background: ${({ theme }) => theme.colors.background};
  }

  &.gradient-bg {
    background: ${({ theme }) => theme.colors.gradientDark};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.spacing['2xl']} 0;
  }
`

export const SectionContainer = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing.md};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 ${({ theme }) => theme.spacing.lg};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 0 ${({ theme }) => theme.spacing.xl};
  }
`

export const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing['4xl']};

  h2 {
    margin-bottom: ${({ theme }) => theme.spacing.md};
    background: ${({ theme }) => theme.colors.gradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  p {
    max-width: 600px;
    margin: 0 auto;
    font-size: ${({ theme }) => theme.fonts.sizes.lg};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: ${({ theme }) => theme.spacing['2xl']};
  }
`

export default Section
